import { type JSX, useState } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { ConfirmationModal, ConfirmationModalOperationType } from 'Components/Modal/ConfirmationModal/ConfirmationModal';
import { Text } from 'Components/Text/Text';
import { ICON_SECURITY } from 'Config/Icons';
import { BasicAuthHandler } from 'Helpers/Auth/BasicAuth/BasicAuthHandler';

import styles from './PublicHeader.module.css';

interface HeaderProps {
    authHandler: BasicAuthHandler;
    logoutDestination: string;
}

/** For third-party users, displays a header at the top of every page where the user can log out. */
export const PublicHeader = (props: HeaderProps): JSX.Element => {
    const [showingLogoutConfirmation, setShowingLogoutConfirmation] = useState(false);

    return (
        <>
            {showingLogoutConfirmation && (
                <ConfirmationModal
                    headerText="Log out"
                    operationType={ConfirmationModalOperationType.NON_DESTRUCTIVE}
                    areYouSureText="Are you sure you want to log out?"
                    buttonIcon={ICON_SECURITY}
                    buttonLoadingText="Logging out..."
                    buttonText="Log out"
                    performOperation={async () => {
                        props.authHandler.logout(props.logoutDestination);
                        return 'Logged out.';
                    }}
                    hideModal={() => setShowingLogoutConfirmation(false)}
                >
                    <Text>Any unsaved changes will be lost.</Text>
                </ConfirmationModal>
            )}
            <div className={styles.header}>
                <div className={styles.headerContent}>
                    <Text noStyles variant="Text2">
                        {props.authHandler.getAuthenticatedUserEmail()}
                    </Text>
                    <Button variant="linkText" size="sm" onClick={() => setShowingLogoutConfirmation(true)}>
                        Log out
                    </Button>
                </div>
            </div>
        </>
    );
};
